import { useCallback } from 'react';

import { chatWebSocketService } from '../chat-websocket.service';
import { WS_ACTIONS } from '../utils/chat-websocket.constants';
import type { TUseBlockUserReturn, TUpdateBlockUserParams } from './use-block-user.types';

/** Envia comando de bloquear/desbloquear usuário via WebSocket. */
export function useBlockUser(): TUseBlockUserReturn {
  const updateBlockUser = useCallback(
    (params: TUpdateBlockUserParams) => {
      chatWebSocketService.send({
        action: WS_ACTIONS.updateBlockUser,
        ChatId: params.chatId,
        UserId: params.userId,
        UserIdToBlock: params.userIdToBlock,
        Blocked: params.blocked,
      });
    },
    [],
  );

  return { updateBlockUser };
}
